import { UseFormRegisterReturn } from "react-hook-form";

import { EXTERNAL_URL } from "~/common/utils/externalURL";
import { TermsAndConditionsSchemaType } from "~/common/utils/signUpSchemas";
import CheckBox from "~/patients/components/ui/CheckBox";

interface TermsAndConditionsProps {
  register: (
    data: keyof TermsAndConditionsSchemaType,
  ) => UseFormRegisterReturn<string>;
  error?: string;
}

export const TermsAndConditions = ({
  register,
  error,
}: TermsAndConditionsProps) => (
  <CheckBox
    id="termsAndConditions"
    {...register("termsAndConditions")}
    error={error}
    labelClassName="text-sm md:text-base"
    containerClassName="items-start"
    className="relative top-0.5 md:top-1"
  >
    <span className="w-full text-left text-gray-600">
      I agree to Psychnow’s{" "}
      <a
        href={EXTERNAL_URL.TERMS_PATIENT}
        className="cursor-pointer border-b border-gray-600 text-sm font-medium text-gray-600 md:text-base"
        target="_blank"
        rel="noreferrer"
      >
        Terms & Conditions
      </a>
      {" and "}
      <a
        href={EXTERNAL_URL.PRIVACY_POLICY}
        className="cursor-pointer border-b border-gray-600 text-sm font-medium text-gray-600 md:text-base"
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </a>
    </span>
  </CheckBox>
);
